import React, { forwardRef, useImperativeHandle, useState } from 'react';
import ReactResizeDetector from 'react-resize-detector';
import { Card, Col, Form, Input, Row } from 'antd';
import { RcFile } from 'antd/es/upload/interface';

import UploadButton from '@lib/components/ui/upload-button';
import { RefFieldSettings } from '@lib/pages/blueprint-data/components/context';
import { BlueprintDataFormRef } from '@lib/pages/blueprint-data/components/form';
import FormGenerator from '@lib/pages/blueprint-data/components/form/form-generator';

import { useInboxContext } from './context';

const InboxMessageForm = forwardRef<BlueprintDataFormRef>((_, ref) => {
  const { blueprint, protos } = useInboxContext();

  const [form] = Form.useForm();
  const [playerId, setPlayerId] = useState<string>();
  const [playerFile, setPlayerFile] = useState<File>();

  useImperativeHandle(ref, () => ({
    onSave: async () => ({
      file: playerFile,
      playerId,
      data: await form.validateFields(),
    }),
  }));

  if (!blueprint) return null;

  const settings = (blueprint?.settings ?? []).reduce<Record<string, RefFieldSettings>>(
    (all, setting) => {
      all[setting.field] = { ...setting, reference: undefined, enumType: undefined };
      return all;
    },
    {},
  );

  const handleFieldChanges = () => {
    // empty
  };

  const handleBeforeUpload = (file: RcFile) => {
    setPlayerFile(file);
    return false;
  };

  return (
    <ReactResizeDetector
      handleWidth
      render={({ width }) => (
        <>
          <Row gutter={8}>
            <Col>
              <Form.Item label="Player Id" name="playerId">
                <Input
                  placeholder="Input Player Id"
                  onChange={(e) => setPlayerId(e.target.value)}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="Player List">
                <UploadButton
                  accept=".csv, .txt"
                  beforeUpload={handleBeforeUpload}
                  buttonProps={{ children: 'Select player list (.csv, .txt)', block: true }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Card size="small" loading={!protos}>
            <div className="font-bold ant-form-item-label">Message</div>
            {protos && (
              <Form layout="vertical" form={form}>
                <FormGenerator
                  blueprint={blueprint}
                  types={protos}
                  form={form}
                  onFieldsChange={handleFieldChanges}
                  fieldSettings={settings}
                  width={Math.min(width, 760)}
                />
              </Form>
            )}
          </Card>
        </>
      )}
    />
  );
});

export default InboxMessageForm;
